import { render, staticRenderFns } from "./MarketInfoEdit.vue?vue&type=template&id=56b7fe84&scoped=true&"
import script from "./MarketInfoEdit.vue?vue&type=script&lang=js&"
export * from "./MarketInfoEdit.vue?vue&type=script&lang=js&"
import style0 from "./MarketInfoEdit.vue?vue&type=style&index=0&id=56b7fe84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b7fe84",
  null
  
)

export default component.exports